import {
  NotificationPage as Data,
  NotificationPageCollection as Collection,
} from '@/typings/api/NotificationPage'
import { BaseApiAuth } from '@/api/BaseApiAuth'


export class NotificationsPagesApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'notifications/pages';
}
